import React, { useState, useRef, useMemo } from "react";

import LazyByScrollComponentWrapper from "./LazyByScrollComponentWrapper";
import useIsInView from "../../hooks/useIsInView";

import "./styles.css";

const LazyByScroll = ({ importCallback, offset }) => {
    const [cmpLoaded, setCmpLoaded] = useState(false);
    const LazyCmp = useMemo(
        () =>
            React.lazy(() =>
                importCallback().then(cmp => {
                    setTimeout(() => {
                        setCmpLoaded(true);
                    }, 200);
                    return cmp;
                })
            ),
        [importCallback]
    );
    const pivotRef = useRef();
    const { isInView: cmpIsInViewport } = useIsInView(pivotRef);
    const showLazyCmp = cmpLoaded || cmpIsInViewport;
    return (
        <LazyByScrollComponentWrapper
            pivotRef={pivotRef}
            LazyCmp={LazyCmp}
            showLazyCmp={showLazyCmp}
            lazyComponentLoaded={cmpLoaded}
            offset={offset}
        ></LazyByScrollComponentWrapper>
    );
};

export default LazyByScroll;
